import { barAdapter } from './barAdapter';
import { comboAdapter } from './comboAdapter';
import { dataTableAdapter } from './dataTableAdapter';
import { heatmapAdapter } from './heatmapAdapter';
import { inferenceCalloutAdapter } from './inferenceCalloutAdapter';
import { kpiAdapter } from './kpiAdapter';
import { kpiBannerAdapter } from './kpiBannerAdapter';
import { lineAdapter } from './lineAdapter';
import { scatterAdapter } from './scatterAdapter';
import { waterfallAdapter } from './waterfallAdapter';
import type { RenderAdapterComponentType } from '../types';

export { barAdapter } from './barAdapter';
export { lineAdapter } from './lineAdapter';
export { dataTableAdapter } from './dataTableAdapter';
export { waterfallAdapter } from './waterfallAdapter';
export { comboAdapter } from './comboAdapter';
export { heatmapAdapter } from './heatmapAdapter';
export { inferenceCalloutAdapter } from './inferenceCalloutAdapter';
export { scatterAdapter } from './scatterAdapter';
export { kpiAdapter } from './kpiAdapter';
export { kpiBannerAdapter } from './kpiBannerAdapter';

export { RenderAdapterError } from '../types';

// `config: never` intentionally loosens the constraint — each adapter accepts
// its own Config type; we only verify keys are exhaustive over
// RenderAdapterComponentType, not unify incompatible config shapes.
//
// `rows: unknown` covers the banner, whose input is keyed by tile id rather
// than being a row array, because its tiles are fetched independently.
export const RENDER_ADAPTER_REGISTRY = {
  BarChart: barAdapter,
  LineChart: lineAdapter,
  DataTable: dataTableAdapter,
  WaterfallChart: waterfallAdapter,
  ComboChart: comboAdapter,
  HeatmapChart: heatmapAdapter,
  Callout: inferenceCalloutAdapter,
  ScatterChart: scatterAdapter,
  KPI: kpiAdapter,
  KPIBanner: kpiBannerAdapter,
} as const satisfies Record<
  RenderAdapterComponentType,
  (rows: unknown, config: never) => unknown
>;
